import axios from 'axios';

// Configuración base de Axios
const axiosInstance = axios.create({
  baseURL: import.meta.env.VITE_API_URL || 'https://apiv1.paseotlaquepaque.mx',
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor para agregar token de autorización
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('access_token');
    if (token) {
      config.headers.Authorization = token;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Interceptor para manejar errores de respuesta
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const url = error.response?.config?.url;
    // No redirigir en rutas donde el 401 es esperado (login y verificación de usuario)
    const excludedUrls = ['/api/user', '/api/login'];
    const shouldRedirect = error.response?.status === 401 && !excludedUrls.includes(url);
    
    if (shouldRedirect) {
      // Redirigir a login si no está autorizado
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
